<ng-template #preHeader>
    SECURE YOUR ACCOUNT
</ng-template>

<ng-template #description>
    We have sent you a text message to {{phoneNo$ | async}}<br />
    Please enter the 4 digit code below to confirm.
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Verify your mobile
</shared-auth-header>

<shared-form-for-cell-verify [modal]="true" [step]="authStep$ | async"></shared-form-for-cell-verify>